










































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter, Action, State } from 'vuex-class';

import { UsersList } from '@/common/Users';

import Brand from '@/services/Brand';

import Modal from './Base.vue';
import Alert from '@/components/Global/Alert.vue';
import TextField from '@/components/Form/TextField.vue';
import SwitchField from '@/components/Form/SwitchField.vue';
import CheckBoxField from '@/components/Form/Checkbox.vue';
import SelectField from '@/components/Form/SelectField.vue';

import jQuery from 'jquery';

@Component({
     name: 'StaffOrganizationInviteUserModal',
     components: {
          Modal,
          Alert,
          TextField,
          CheckBoxField,
          SwitchField,
          SelectField,
     },
})
export default class StaffOrganizationInviteUserModal extends Vue {
     @Prop(Function) private submit!: any;
     // tslint:disable-next-line
     @Prop(String) private org_id!: string;

     @State('users', { namespace: 'Users' }) private users: UsersList[];
     @Action('inviteUser', { namespace: 'Organizations' }) private inviteUserToOrg!: any;
     @Getter('clientIds', { namespace: 'Organizations' }) private clientIds: {
          [index: string]: {
               name: string;
               brand: string;
               policies: string[];
               client_id?: string;
          };
     };

     private error: boolean = false;
     private success: boolean = false;
     private exists: boolean = false;

     private Brands: object = Brand.getBrandsObject();
     private form: any = {
          name: '',
          email: '',
          isOrgAdmin: true,
          client_ids: [],
          brand: '',
          org_id: this.org_id,
     };

     private async checkForUserAccount(email) {
          const userEmails = [];
          this.users.forEach(user => {
               userEmails.push(user.email);
          });
          if (userEmails.includes(email)) {
               this.exists = true;
               this.error = true;
          }
     }

     private async inviteUser() {
          this.error = false;
          this.success = false;

          try {
               const userEmailtoCheck = this.form.email.toLowerCase();
               await this.checkForUserAccount(userEmailtoCheck);
          } catch (e) {
               this.error = true;
               console.log(e);
          } finally {
               if (this.error === false) {
                    const invite = await this.inviteUserToOrg(this.form);
                    jQuery('#staffOrgaizationInviteUser').modal('hide');

                    this.$router.push({
                         name: 'stafforganizationtabbed',
                         params: {
                              org_id: this.$route.params.org_id,
                              tab: 'invites',
                         },
                    });
               }
          }
     }

     private async created() {
          await this.$store.dispatch('Users/getAllUsers');
     }
}
